/* Keep Recharge shipping copy aligned with the store policy, including renewals. */
(() => {
  const observed = new WeakSet();
  const oldCopy = /first\s+order\s+ships\s+free/gi;
  const newCopy = 'Free standard shipping on every US order';
  function sync(root) {
    if (!observed.has(root)) {
      observed.add(root);
      new MutationObserver(() => sync(root)).observe(root, { childList: true, subtree: true, characterData: true });
    }
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/first\s+order\s+ships\s+free/i.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(oldCopy, newCopy);
    }
    root.querySelectorAll('*').forEach(el => { if (el.shadowRoot) sync(el.shadowRoot); });
  }
  function scan() {
    document.querySelectorAll('recharge-subscription-widget').forEach(widget => { if (widget.shadowRoot) sync(widget.shadowRoot); });
  }
  scan();
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  // Custom elements can attach their shadow roots after insertion without a DOM mutation.
  setInterval(scan, 1000);
})();
